import { type Merchant } from "types/merchant";
import { useSelector } from "react-redux";
import { useApi } from "hooks/useAPI";
import { useEffect, useState } from "react";
import {
  CompareOption,
  SalesService,
  SalesSummaryData,
} from "services/SalesService";
import { getLocalTime } from "utils/getLocalTime";
import { Grid } from "@mui/material";
import VuiBox from "components/VuiBox";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { ROASWidget } from "views/app-views/dashboards/facebook/HeaderWidget/ROASWidget";
import { CPAWidget } from "views/app-views/dashboards/facebook/HeaderWidget/CPAWidget";
import { CVRWidget } from "views/app-views/dashboards/facebook/HeaderWidget/CVRWidget";
import { AOVWidget } from "views/app-views/dashboards/facebook/HeaderWidget/AOVWidget";
export const HeaderWidgets = () => {
  const { get } = useApi();

  const selectedMerchant: Merchant = useSelector(
    (state: any) => state.merchants.selectedMerchant
  );
  const facebookData = useSelector((state: any) => state.facebookData.data);
  const {
    startDate,
    endDate,
    compareOption,
  }: { startDate: Date; endDate: Date; compareOption: CompareOption } =
    useSelector((state: any) => state.common);
  const [loading, setLoading] = useState<boolean>(false);

  const [summary, setSummary] = useState<SalesSummaryData | null>(null);


  useEffect(() => {
    const fetchSummary = async () => {
      const salesSummary = new SalesService(get);

      const { startDateString, endDateString } = getLocalTime(
        startDate,
        endDate
      );

      setLoading(true);
      const result = await salesSummary.getSummary({
        merchantId: selectedMerchant.id,
        start: startDateString,
        end: endDateString,
        compareOption: compareOption,
      });
      setLoading(false);
      setSummary(result);
    };

    if (selectedMerchant && startDate && endDate) {
      fetchSummary();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMerchant, startDate, endDate, compareOption]);

  return (
    <>
      <Grid item xs={12} sm={6} lg={3}>
        <VuiBox mb={3}>
          <ROASWidget
            title="ROAS"
            loading={loading}
            value={facebookData?.roas || 0}
            compareValue={summary?.revenue.compareValue || 0}
          />
        </VuiBox>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <VuiBox mb={3}>
          <CPAWidget
            title="CPA"
            loading={loading}
            facebookData={facebookData || { graphData: [] }}
            currency={selectedMerchant.currency || "USD"}
          />
        </VuiBox>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <VuiBox mb={3}>
          <CVRWidget
            title="CVR"
            loading={loading}
            facebookData={facebookData || { graphData: [] }}
          />
        </VuiBox>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <VuiBox mb={3}>
          <AOVWidget
            title="AOV"
            loading={loading}
            facebookData={facebookData || { graphData: [] }}
            currency={selectedMerchant.currency || "USD"}
          />
        </VuiBox>
      </Grid>
    </>
  );
};
